import { COUNTRIES, CountryFilter, CountryFilterType } from '@monorepo/types';
import auStates from '../assets/au-states.json';
import caStates from '../assets/ca-states.json';
import usStates from '../assets/us-states.json';

const countryToStates = {
  us: usStates,
  ca: caStates,
  au: auStates,
} as const;

export type CountryWithStates = keyof typeof countryToStates;

export const COUNTRIES_WITH_STATES: CountryWithStates[] = Object.keys(
  countryToStates,
) as CountryWithStates[];

export const getStates = (country: string) => {
  return countryToStates[country.toLowerCase() as CountryWithStates];
};

export const hasStates = (country: string): country is CountryWithStates => {
  return COUNTRIES_WITH_STATES.includes(
    country.toLowerCase() as CountryWithStates,
  );
};

export const getCountries = (
  filter?: CountryFilter,
): { text: string; value: string }[] => {
  if (filter) {
    return COUNTRIES.filter((country) =>
      filter.type === CountryFilterType.Exclude
        ? !filter.countries.includes(country.value)
        : filter.countries.includes(country.value),
    );
  }

  return [...COUNTRIES];
};
